export const UPDATE_REQUEST_CACHE = 'cache.UPDATE_REQUEST_CACHE';
export const UPDATE_STATE_CACHE = 'cache.UPDATE_STATE_CACHE';